import script from "./device.vue?vue&type=script&lang=js&setup=true"
export * from "./device.vue?vue&type=script&lang=js&setup=true"

import "./device.vue?vue&type=style&index=0&id=520cc489&lang=scss&scoped=true"
import "./device.vue?vue&type=style&index=1&id=520cc489&lang=css"

import exportComponent from "C:\\Project\\DeepLink\\OrionRaceWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520cc489"]])

export default __exports__